import React from 'react';
import styles from './style.module.scss';
import Checkbox from '../../../../components/Checkbox/Index';
import Row from './row';
import useMccStore from '../../../../stores/mcc';

const Table = ({
  data,
  fetchData
}) => {

  const searchFilters = useMccStore(state => state.searchFilters);
  const setSearchFilters = useMccStore(state => state.setSearchFilters);
  const selectedMcc = useMccStore(state => state.selectedMcc);
  const setSelectedMcc = useMccStore(state => state.setSelectedMcc);


  const onSortClick = (type) => {
    setSearchFilters({
      ...searchFilters,
      sortBy: type,
      sortColumn: searchFilters.sortColumn == 'ASC' ? 'DESC' : 'ASC'
    })
  }

  const onCheckAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedMcc(data.map(item => item.id))
    } else {
      setSelectedMcc([])
    }
  }

  return (
    <table className={styles.table} >
      <thead className={styles.tableHead} >
        <tr className={styles.theadRow} >
          <th className={`${styles.th} ${styles.w40px}`} >
            <Checkbox
              checked={selectedMcc.length == data.length}
              onChange={onCheckAll}
            />
          </th>
          <th className={`${styles.th} ${styles.w140px}`} onClick={() => onSortClick('id')} >
            <div className={styles.flex} >
              <span>ID</span>

              {searchFilters?.sortBy == 'id' && (
                <span className={`${searchFilters?.sortBy == 'id' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}

            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`} onClick={() => onSortClick('mcc')} >
            <div className={styles.flex} >
              <span>MCC</span>
              {searchFilters?.sortBy == 'mcc' && (
                <span className={`${searchFilters?.sortBy == 'mcc' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th}`} onClick={() => onSortClick('category')} >
            <div className={styles.flex} >
              <span>Category</span>
              {searchFilters?.sortBy == 'category' && (
                <span className={`${searchFilters?.sortBy == 'category' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th}`} onClick={() => onSortClick('description')} >
            <div className={styles.flex} >
              <span>Description</span>
              {searchFilters?.sortBy == 'description' && (
                <span className={`${searchFilters?.sortBy == 'description' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`} >
            Risk Type
          </th>
          <th className={`${styles.th} ${styles.w40px}`} ></th>
        </tr>
      </thead>

      <tbody className={styles.tableBody} >
        {data.map((item, index) => (
          <Row key={index} data={item} fetchData={fetchData} />
        ))}
      </tbody>
    </table>
  )
}

export default Table